import Shortcuts from './Shortcuts';

export default Shortcuts;
